export default {"src":"/_next/static/media/droneOutline75_40.9ac8f021.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};